/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Block_Requires_SyncInputs */



/**
* | output |
* | --- |
* | "Blocking requires synchronous mode to be enabled." |
*
* @param {Compliance_Copilot_Block_Requires_SyncInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_block_requires_sync = /** @type {((inputs?: Compliance_Copilot_Block_Requires_SyncInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Block_Requires_SyncInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Blockieren erfordert den synchronen Modus.")
	return /** @type {LocalizedString} */ ("Blocking requires synchronous mode to be enabled.")
});